import { Center, Loader, Portal } from '@mantine/core';
import { useUnit } from 'effector-react';
import { sharedModel } from 'shared/model';
import cls from './page-loader.module.scss';

export const PageLoader = () => {
	const isLoading = useUnit(sharedModel.$routeLoading);

	if (!isLoading)
		return (
			<Portal>
				<Center className={cls.pageLoader}>
					<Loader className={cls.pageLoaderLoader} />
				</Center>
			</Portal>
		);

	return null;
};
